import React from 'react';
import { Check } from 'lucide-react';
import {
  countWords,
  estimateReadingMinutes,
  answerQualityMessage,
} from '../../utils/storybookGuidance';

export function StorybookAnswerMetrics({
  body,
  completed,
  recordingCount = 0,
  transcriptStatusLabel,
}) {
  const words = countWords(body);
  const readMin = estimateReadingMinutes(words);
  const quality = answerQualityMessage(words, completed);

  return (
    <div
      className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-muted-foreground"
      data-testid="storybook-answer-metrics"
    >
      <span className="tabular-nums">{words} words</span>
      {words > 0 ? <span>About {readMin} min read</span> : null}
      {recordingCount > 0 ? (
        <span>
          {recordingCount} voice recording{recordingCount === 1 ? '' : 's'} attached
        </span>
      ) : null}
      {transcriptStatusLabel ? <span>{transcriptStatusLabel}</span> : null}
      {completed ? (
        <span className="flex items-center gap-1 text-primary">
          <Check className="h-3 w-3" /> Marked complete
        </span>
      ) : quality ? (
        <span className="italic text-muted-foreground/80">{quality}</span>
      ) : null}
    </div>
  );
}

export default StorybookAnswerMetrics;
